import {
  GenerateCropFromRectilinearInput,
  GenerateImageInput,
  useFetchCropFromRectilinearLazyQuery,
  useFetchGenerateImageLazyQuery,
} from '@/__generated__/graphql';
import { useCallback } from 'react';

export const useGenerateImage = () => {
  const [fetchSphericalImageCrop] = useFetchGenerateImageLazyQuery({
    fetchPolicy: 'no-cache',
  });
  const [fetchRectilinearImageCrop] = useFetchCropFromRectilinearLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const fetchCropFromRectilinear = useCallback(
    async (input: GenerateCropFromRectilinearInput) => {
      return fetchRectilinearImageCrop({
        variables: {
          input: input,
        },
      }).then(({ data }) => {
        return data?.fetchCropFromRectilinear?.imageData ?? undefined;
      });
    },
    [fetchRectilinearImageCrop]
  );

  const fetchCropFromSpherical = useCallback(
    async (input: GenerateImageInput) => {
      return fetchSphericalImageCrop({
        variables: {
          input: input,
        },
      }).then(({ data }) => {
        return data?.fetchGenerateImage?.imageData ?? undefined;
      });
    },
    [fetchSphericalImageCrop]
  );

  return { fetchCropFromSpherical, fetchCropFromRectilinear };
};
